import { render, staticRenderFns } from "./ReportDonutChart.vue?vue&type=template&id=2abd3142&"
import script from "./ReportDonutChart.vue?vue&type=script&lang=js&"
export * from "./ReportDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports